{
  "titles": {
    "menu": "Spaarcontracten",
    "table": "Contracten",
    "create": "Contract aanmaken",
    "update": "Contract wijzigen",
    "documents": "Documenten",
    "finalPayment": "Eindafrekening"
  },
  "fields": {
    "labels": {
      "funderId": "Spaarder",
      "referenceNumber": "Contractnummer",
      "startDate": "Startdatum",
      "endDate": "Einddatum",
      "variant": "Variant",
      "amount": "Inleg",
      "interestRate": "Rente",
      "durationInMonths": "Looptijd",
      "period": "Contractperiode",
      "interestPeriod": "Renteperiode",
      "funderName": "Spaarder",
      "interestCurrentMonth": "Rente {month}",
      "monthlyInterest": "Maandrente",
      "iban": "IBAN",
      "bic": "BIC",
      "beneficiaryName": "Naam rekeninghouder",
      "depositDate": "Datum gelden ontvangen",
      "isNameCorrect": "Naam rekeninghouder correct",
      "expirationReason": "Reden",
      "expirationExplanation": "Toelichting",
      "declinedReason": "Reden",
      "declinedExplanation": "Toelichting",
      "reimbursementDate": "Datum terugbetaling",
      "topUp": "Bijstorting",
      "fileContract": "Getekend contract incl verklaring herkomst gelden",
      "reimbursementAmount": "Spaarder ontvangt terug",
      "reimbursementDescription": "Omschrijving",
      "renewalOption": "Verlengingsoptie",
      "deviations": {
        "interestRate": {
          "value": "Afwijkende rente",
          "explanation": "Toelichting"
        },
        "durationInMonths": {
          "value": "Afwijkende looptijd",
          "explanation": "Toelichting"
        }
      },
      "previousContract": "Voorgaand contract"
    },
    "hints": {
      "depositDate": "Rente vanaf {date}"
    },
    "validationErrors": {
      "startDate": {
        "minDate": "{0} moet in de toekomst liggen"
      },
      "depositDate": {
        "before": "{0} mag niet in de toekomst liggen en moet voor de einddatum van het contract zijn"
      }
    }
  },
  "headers": {
    "labels": {
      "interestCurrentMonth": "Rente {month}",
      "interestRate": "Rente percentage",
      "status": "Status"
    }
  },
  "messages": {
    "tacitlyRenewed": "Stilzwijgend verlengd",
    "createSuccess": "Contract aangemaakt",
    "updateSuccess": "Contract is opgeslagen",
    "rateAndInterest": "{percentage} ({monthlyInterest} per maand)",
    "rateNotAvailable": "Vul velden in om de rente te berekenen",
    "expiringSoon": "Dit contract verloopt binnenkort",
    "noDocuments": "Geen documenten beschikbaar",
    "statusFunderFieldsMissing": "De volgende velden van de spaarder zijn niet (juist) ingevuld:",
    "statusFundingContractFieldsMissing": "De volgende velden van het spaarcontract zijn niet (juist) ingevuld:",
    "statusAccountFieldsMissing": "De volgende velden van een van de accounts is niet (juist) ingevuld:",
    "contractStatusInProgress": "in behandeling",
    "renewedContractAutoToStatusActive": "Dit contract is een verlenging van een voorgaand contract. De gelden zijn al binnen en het contract zal automatisch op {date} actief worden!",
    "deviateInterest": "Afwijkende rente aanvragen",
    "deviatedInterest": "Er wordt afgeweken van de rente zodra u opslaat",
    "deviationPending": "Afwijkende aanvraag in behandeling",
    "deviationApproved": "Afwijkende aanvraag goedgekeurd",
    "deviationNotADeviation": "De afwijking, is niet daadwerkelijk een afwijking",
    "deviateDuration": "Afwijkende looptijd aanvragen",
    "deviatedDuration": "Afwijkende looptijd wordt aangevraagd",
    "deviateReject": "Voorgestelde rente afwijzen",
    "alerts": {
      "newContract": "De inleg is in goede orde ontvangen en alle documenten zijn gecontroleerd. De spaarder zal rente ontvangen vanaf {startDateInterest}.",
      "renewAndTopUp": "De bijstorting is in goede orde ontvangen en alle documenten zijn gecontroleerd. De spaarder zal rente ontvangen vanaf {startDateInterest}",
      "renewal": "De inleg is reeds in goede orde ontvangen en alle documenten zijn gecontroleerd. De spaarder zal rente ontvangen vanaf {startDateInterest}.",
      "isDissolved": "Dit contract is ontbonden",
      "isCanceled": "Dit contract is geannuleerd"
    }
  },
  "actions": {
    "create": "Contract aanmaken",
    "update": "Contract aanpassen",
    "updateDeclaration": "Verklaring herkomst middelen",
    "search": "Zoek een spaarcontract",
    "statusChange": "Status wijzigen",
    "DraftToSentDigital": "Digitaal verzenden",
    "DraftToSentManually": "Handmatig verzenden",
    "SentManuallyToSignedByFunder": "Contract getekend",
    "SentManuallyToDraft": "Contract opnieuw bewerken",
    "SentManuallyToInactive": "Contract afwijzen",
    "SentDigitalToDraft": "Contract opnieuw bewerken",
    "SentDigitalToInactive": "Contract afwijzen",
    "SignedByFunderToActive": "Gelden ontvangen",
    "SignedByFunderToInactive": "Contract ontbinden",
    "ActiveToInactive": "Contract ontbinden",
    "renew": "Contract verlengen",
    "expire": "Niet verlengen",
    "export": "Exporteren",
    "scheduled": "Ingepland"
  },
  "declarationOfSourceOfFunds": {
    "titles": {
      "declarationOfSourceOfFunds": "Verklaring herkomst middelen",
      "addSource": "Herkomst toevoegen",
      "totalDeclared": "Totaal verklaard"
    },
    "explanation": "Beschrijf kort waar de middelen vandaan komen, bijvoorbeeld uit winst uit onderneming of uit een schenking. Deze informatie wordt verwerkt in de Verklaring Herkomst Middelen die ter ondertekening wordt aangeboden.",
    "fields": {
      "labels": {
        "depositAmount": "Inleg bedrag",
        "type": "Type herkomst",
        "amount": "Bedrag",
        "companyName": "Bedrijfsnaam",
        "donatedBy": "Schenking door",
        "relationToDonor": "Relatie met schenker",
        "explanation": "Toelichting",
        "borrowedFrom": "Geleend bij",
        "relationToLender": "Relatie met geldverstrekker",
        "hasAgreement": "Is er een leningsovereenkomst?",
        "hasAgreementTrue": "Ja",
        "hasAgreementFalse": "Nee",
        "fileId": "Leningsovereenkomst toevoegen"
      },
      "hints": {
        "amount": "Vul hier het bedrag in dat verklaard wordt",
        "companyName": "Vul hier de naam van het bedrijf in",
        "borrowedFrom": "Vul hier de naam van de geldverstrekker in",
        "relationToLender": "Vul hier de relatie met de geldverstrekker in bijvoorbeeld: 'vader'",
        "donatedBy": "Vul hier de naam van de schenker in",
        "relationToDonor": "Vul hier de relatie met de schenker in"
      }
    },
    "enums": {
      "fundSourceType": {
        "Turnover": "Winst uit onderneming",
        "Loan": "Geleend bij",
        "Donation": "Schenking door",
        "Other": "Anders, namelijk"
      }
    },
    "actions": {
      "addSource": "Herkomst toevoegen",
      "update": "Verklaring opslaan",
      "deleteSource": "Herkomst verwijderen"
    },
    "messages": {
      "amountOverDeclared": "Er is {amount} te veel verklaard",
      "percentDeclared": "{percent}% verklaard",
      "remainingToGo": "Nog {amount} te gaan",
      "updateSuccess": "Verklaring herkomst middelen is opgeslagen",
      "readOnly": "Deze verklaring kan niet meer worden aangepast."
    },
    "requested": {
      "title": "Bedankt!",
      "message": "We hebben de aanvraag ontvangen en gaan deze controleren. De spaarder ontvangt een bericht van ons zodra we het contract ter ondertekening aanbieden. De voortgang is te volgen in dit partnerportaal.",
      "action": "Terug naar overzicht"
    }
  }
}
